import React from 'react'
import PropTypes from 'prop-types'
import { isEmpty } from 'react-redux-firebase'
import AppSettings from '../AppSettings/AppSettings'
import Logout from '../AppAuth/Logout'

import './AppHeader.css'

const AppHeader = ({ profile }) => {
  let AppSettingsLoaded = ''

  if(!isEmpty(profile)) {
    AppSettingsLoaded = (
      <React.Fragment>
      <Logout />
      <AppSettings user={profile} />
      </React.Fragment>
    )
  }
  return (
    <section className='app-header'>
      <div className='app-logo'>
        <span className='app-logo__black'>easy</span>
        :
        <span className='app-logo__orange'>Time</span>
      </div>
      {AppSettingsLoaded}
    </section>
  )
}

AppHeader.propTypes = {
  profile: PropTypes.shape({
    displayName: PropTypes.string
  })
}

export default AppHeader



// WEBPACK FOOTER //
// ./src/components/AppHeader/AppHeader.js